import { render, staticRenderFns } from "./ProjectTile.vue?vue&type=template&id=6a8da7fa&"
import script from "./ProjectTile.vue?vue&type=script&lang=js&"
export * from "./ProjectTile.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTile.vue?vue&type=style&index=0&id=6a8da7fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports